module.exports = __webpack_public_path__ + "media/assets/icons/thought-balloon-245101c3c0fda485cfa487107c634625.svg";